import React from 'react';
import { MyChatBubble } from '../players/MyChatBubble';
import { gql } from '@urql/core';
import { CollegeChatBubblesFragment, Espin_Message_Type_Enum } from '../../../../generated/spin-graphql';
import { CollegeIncomingChatBubble } from './CollegeIncomingChatBubble';
import { collegeConversationSelectProfileImage } from './CollegeSelectedConversation';

type Props = {
    conversation?: CollegeChatBubblesFragment[];
};

gql`
    fragment CollegeChatBubbles on espin_message {
        ...CollegeIncomingChatBubble
        ...MyChatBubble
        message_type
        player_user {
            player_profile {
                profile_image {
                    ...SpinContentImageDisplay
                }
            }
            deleted_at
        }
        high_school {
            name
            profile_pic_file {
                ...SpinContentImageDisplay
            }
        }
    }
`;

export const CollegeChatBubbles: React.FC<Props> = ({ conversation }) => {
    const profileImage = collegeConversationSelectProfileImage(conversation[0]);
    return (
        <div className="chat-bubbles-container">
            {conversation.map((message, index) => {
                if (
                    message.message_type === Espin_Message_Type_Enum.CollegeMessagesPlayer ||
                    message.message_type === Espin_Message_Type_Enum.CollegeMessagesHighSchool
                ) {
                    return <MyChatBubble key={`chat-bubble-${index}`} message={message} />;
                }

                return (
                    <CollegeIncomingChatBubble key={`chat-bubble-${index}`} picture={profileImage} message={message} />
                );
            })}
        </div>
    );
};
